'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultProxyGenerator = exports.addMerge = exports.getUniqueFactor = exports.buildTable2D = exports.getPercentageHtml = exports.getRoundedHtmlValue = exports.getNumberOfDecimals = exports.toRow = exports.getValue = exports.roundIf = undefined;

var _numberToFixed = require('d2-utilizr/lib/numberToFixed');

var _numberToFixed2 = _interopRequireDefault(_numberToFixed);

var _isNumber = require('d2-utilizr/lib/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isBoolean = require('d2-utilizr/lib/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @description round number if needed.
 *  @param   {number} number 
 *  @param   {number} precision 
 *  @returns {number}
 */
var roundIf = exports.roundIf = function roundIf(number, precision) {
    number = parseFloat(number);
    precision = parseFloat(precision);

    if ((0, _isNumber2.default)(number) && (0, _isNumber2.default)(precision)) {
        var numberOfDecimals = getNumberOfDecimals(number);
        return numberOfDecimals > precision ? (0, _numberToFixed2.default)(number, precision) : number;
    }

    return number;
};

/** @description gets integer representation of given string.
 *  @param   {string} str 
 *  @returns {number}
 */
var getValue = exports.getValue = function getValue(str) {
    var n = parseFloat(str);

    if ((0, _isBoolean2.default)(str)) {
        return 1;
    }

    if (!(0, _isNumber2.default)(n) || n != str) {
        return 0;
    }

    return n;
};

/** @description turns array of arrays into a single row.
 *  @param   {array} array 
 *  @returns {array}
 */
var toRow = exports.toRow = function toRow(array) {

    if (!(0, _isArray2.default)(array[0])) {
        return [array];
    }

    var row = new Array(array[0].length);

    for (var i = 0; i < row.length; i++) {
        row[i] = [];
    }

    for (var _i = 0; _i < array.length; _i++) {
        for (var j = 0; j < array[_i].length; j++) {
            row[j].push(array[_i][j]);
        }
    }

    return row;
};

/** @description returns the number of decumal of given float
 *  @param   {number} number 
 *  @returns {number}
 *  @deprecated should switch to use function located in d2-utilizr
 */
var getNumberOfDecimals = exports.getNumberOfDecimals = function getNumberOfDecimals(number) {
    var str = new String(number);
    return str.indexOf('.') > -1 ? str.length - str.indexOf('.') - 1 : 0;
};

/** @description returns the rounded value of the given float.
 *  @param   {number} value 
 *  @param   {number} [dec=2] 
 *  @returns {number}
 */
var getRoundedHtmlValue = exports.getRoundedHtmlValue = function getRoundedHtmlValue(value) {
    var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    return parseFloat(roundIf(value, 2)).toString();
};

/** @description get percentage representation of value.
 *  @param   {number} value 
 *  @param   {number} total 
 *  @returns {string}
 */
var getPercentageHtml = exports.getPercentageHtml = function getPercentageHtml(value, total) {
    return getRoundedHtmlValue(value / total * 100) + '%';
};

/** @description Builds a 2D array with the given dimensions
 *  @param   {number} rows
 *  @param   {number} columns
 *  @returns {array}  
 */
var buildTable2D = exports.buildTable2D = function buildTable2D(rows, columns, fill) {
    var table2D = new Array(rows);

    for (var i = 0; i < rows; i++) {
        table2D[i] = new Array(columns);
        if (typeof fill !== 'undefined') table2D[i].fill(fill);
    }

    return table2D;
};

var getUniqueFactor = exports.getUniqueFactor = function getUniqueFactor(axis) {
    if (axis.xItems && axis.xItems.unique) {
        return axis.xItems.unique.length < 2 ? 1 : axis.size / axis.xItems.unique[0].length;
    }
    return null;
};

var addMerge = exports.addMerge = function addMerge(a, b) {
    Object.keys(a).forEach(function (key) {
        if (b[key]) {
            a[key] += b[key];
        }
    });
};

var defaultProxyGenerator = exports.defaultProxyGenerator = function defaultProxyGenerator(defaultReturnValue) {
    return new Proxy({}, { get: function get(target, name) {
            return name in target ? target[name] : defaultReturnValue;
        } });
};
//# sourceMappingURL=PivotTableUtils.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/table/PivotTableUtils.js
 ** module id = 57
 ** module chunks = 0 1
 **/